import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export interface FileUploadResponse {
  url: string;
  path?: string;
  imageUrl?: string;
  fileUrl?: string;
  fileName?: string;
}

export type PublicUploadPurpose = 'catalog' | 'brand' | 'marketing' | 'careers' | 'general';

export interface FileUploadOptions {
  directory?: string;
  name?: string;
  isPublic?: boolean;
  purpose?: PublicUploadPurpose;
  employeeId?: number;
}

export const filesApi = {
  upload: (file: File, directoryOrOptions?: string | FileUploadOptions, name?: string) => {
    const options: FileUploadOptions =
      typeof directoryOrOptions === 'string' || directoryOrOptions == null
        ? { directory: directoryOrOptions, name }
        : directoryOrOptions;
    const form = new FormData();
    form.append('file', file);
    if (options.directory) {
      form.append('directory', options.directory);
      form.append('folder', options.directory);
    }
    if (options.name) form.append('name', options.name);
    if (options.isPublic) form.append('isPublic', 'true');
    if (options.purpose) form.append('purpose', options.purpose);
    if (options.employeeId != null) form.append('employeeId', String(options.employeeId));
    return unwrap(
      api.post<ApiResponse<FileUploadResponse>>('/v1/files/upload', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    );
  },

  uploadDocument: (file: File, nameOrOptions?: string | FileUploadOptions) => {
    const options: FileUploadOptions =
      typeof nameOrOptions === 'string' || nameOrOptions == null
        ? { name: nameOrOptions }
        : nameOrOptions;
    const form = new FormData();
    form.append('file', file);
    form.append('directory', options.directory ?? 'documents');
    if (options.name) form.append('name', options.name);
    if (options.isPublic) form.append('isPublic', 'true');
    if (options.purpose) form.append('purpose', options.purpose);
    if (options.employeeId != null) form.append('employeeId', String(options.employeeId));
    return unwrap(
      api.post<ApiResponse<FileUploadResponse>>('/v1/files/upload/document', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    );
  },
};
